"use client";

/**
 * ECON social links: used as job-detail section `socialSection` (registry/econ/default)
 * and as the job-board `TeaserBar` slot (registry/econ/index).
 */
import { c as _c } from "react/compiler-runtime";
import { SocialLink, type SocialPlatform } from "@repo/design-system/components/social-link";
import { useLanguage } from "~/translations/loader/use-language";
const socialLinks: {
  platform: SocialPlatform;
  href: string;
  name: string;
  labelKey: "econ_social_linkedin" | "econ_social_instagram" | "econ_social_spotify";
}[] = [{
  platform: "linkedin",
  href: "https://www.linkedin.com/company/5906913/",
  name: "LinkedIn",
  labelKey: "econ_social_linkedin"
}, {
  platform: "instagram",
  href: "https://www.instagram.com/eon_inhouse_consulting/",
  name: "Instagram",
  labelKey: "econ_social_instagram"
}, {
  platform: "spotify",
  href: "https://open.spotify.com/show/2CuF85rAx1ruBFwKRkvVJH",
  name: "Spotify",
  labelKey: "econ_social_spotify"
}];
export default function SocialSectionEcon() {
  const $ = _c(4);
  const t = useLanguage();
  let t0;
  if ($[0] !== t) {
    t0 = socialLinks.map(social => <li key={social.platform}><SocialLink className="block h-full min-h-[240px] w-full rounded-none bg-primary p-8 text-white shadow-none transition-all duration-300 hover:brightness-90" classNameIcon="text-white size-12" href={social.href} social={social.platform}><p className="mt-4 font-bold text-3xl">{social.name}</p><p className="mt-4 text-lg" data-source="lc">{t[social.labelKey]}</p></SocialLink></li>);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <section className="outer-container bg-card py-10 md:py-20 print:hidden"><div className="inner-container"><ul className="grid w-full auto-cols-fr grid-flow-row auto-rows-fr gap-5 md:grid-flow-col xl:gap-8">{t0}</ul></div></section>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}